import { navigateToUrl } from 'single-spa';
import React from 'react';
const Link = ({ to, children, className }) => {
  return (
    <a
      className={className}
      style={{ cursor: 'pointer' }}
      href={to}
      onClick={(e) => {
        e.preventDefault();
        navigateToUrl(to);
      }}
    >
      {children}
    </a>
  );
};
export default Link;
